import React from "react";
import styles from "./ClientForm.module.css";

function CurrencyInput({ value, onChange, placeholder }) {
  const formatNumber = (val) => {
    if (!val) return "";
    return Number(val).toLocaleString(); // ✅ adds commas automatically
  };

  const handleChange = (e) => {
    const raw = e.target.value.replace(/,/g, ""); // remove commas
    if (!isNaN(raw)) {
      onChange(raw);
    }
  };

  return (
    <div className={styles.currencyInput}>
      <span className={styles.dollarSign}>$</span>
      <input
        type="text"
        value={formatNumber(value)}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </div>
  );
}

export default CurrencyInput;
